import { Flex, Space, Tooltip } from 'antd';

import { Schemas } from '@api-client/generated/types';
import { IconClock, IconLock } from '@assets';

import { getDocumentErrorReason } from '@utils';

import * as S from './styled';

export type DocumentStatus = Schemas.Document['adminStatus'];
export type BobStatus = Schemas.Document['bobStatus'];

type DocumentExpenseStatusProps = {
  status: DocumentStatus;
  bobStatus?: BobStatus;
  /** The error facet, read through the same helper the list tag uses so the two cannot disagree. */
  hasError?: boolean;
  errorCode?: string | null;
  bobPendingAt?: string | null;
}

const DocumentExpenseStatus = ({
  status,
  bobStatus,
  hasError,
  errorCode,
  bobPendingAt,
}: DocumentExpenseStatusProps) => {
  const isProcessing = status === 'processing';
  const isBooked = status === 'processed';
  const errorReason = getDocumentErrorReason({ adminStatus: status, bobStatus, hasError, errorCode, bobPendingAt });

  return (
    <S.Status status={status}>
      <Space split={<S.Divider />}>
        <S.StatusName status={status}>
          {isProcessing && (
            <Flex align="center" gap={6}>
              In Work {bobStatus === 'pending' ? '(automatic)' : '(manual)'} <IconClock />
            </Flex>
          )}

          {isBooked && (
            <Flex align="center" gap={6}>
              Booked {bobStatus === 'succeeded' ? '(automatic)' : '(manual)'} <IconLock />
            </Flex>
          )}
        </S.StatusName>

        {errorReason && (
          // Beside the status, never instead of it: a document booked by hand and later flagged is
          // still booked, and calling it "Error" hid the one fact the operator needed.
          <Tooltip title={errorReason}>
            <S.Details aria-label={`Error: ${errorReason}`}>⚠ {errorReason}</S.Details>
          </Tooltip>
        )}

        {isBooked && (
          <>
            <S.Details>Book date: TBD</S.Details>
            <S.Details>Time to book: TBD</S.Details>
          </>
        )}
      </Space>
    </S.Status>
  );
};

export default DocumentExpenseStatus;
